export default __webpack_public_path__ + "static/compareItemImg5-8603a0cfc5a59892e8f4c1689fe955c6.png";